import type React from "react"
import { Route, Routes, Navigate } from "react-router-dom"
import AdminLayout from "../layouts/AdminLayout"
import ManageBookings from "../pages/admin/ManageBookings"
import ManageLanes from "../pages/admin/ManageLanes"
import Dashboard from "../pages/admin/Dashboard"
import ProtectedRoute from "./ProtectedRoute"
import Payments from "../pages/admin/Payment"
import Enquirys from "../pages/admin/Enquiry"
import ManageMemberships from "../pages/admin/memberships/ManageMemberships"
import ManagePrograms from "../pages/admin/programs/ManagePrograms"
import ManageProgramSessions from "../pages/admin/programs/ManageProgramSessions"
import ManageProgramEnrollments from "../pages/admin/programs/ManageProgramEnrollments"
import WebsitePopupAdmin from "../pages/admin/WebsitePopup"
import ManageUsers from "../pages/admin/users/ManageUsers"

// Component to handle role-based access
const RoleBasedRoute = ({ children, allowedRoles }: { children: React.ReactNode; allowedRoles: string[] }) => {
  const userType = localStorage.getItem("userType")

  if (!allowedRoles.includes(userType || "")) {
    // Redirect employees trying to access admin-only routes to manage-bookings
    return <Navigate to="/admin/manage-bookings" replace />
  }

  return <>{children}</>
}

const AdminRoutes = () => {
  const userType = localStorage.getItem("userType")

  return (
    <AdminLayout>
      <Routes>
        <Route element={<ProtectedRoute />}>
          {/* Default route - redirect based on user type */}
          <Route
            path=""
            element={<Navigate to={userType === "employee" || userType === "employee_admin" ? "/admin/manage-bookings" : "/admin/dashboard"} replace />}
          />

          {/* Admin-only routes */}
          <Route
            path="dashboard"
            element={
              <RoleBasedRoute allowedRoles={["admin"]}>
                <Dashboard />
              </RoleBasedRoute>
            }
          />
          <Route
            path="manage-lanes"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee_admin"]}>
                <ManageLanes />
              </RoleBasedRoute>
            }
          />
          <Route
            path="website-popup"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin"]}>
                <WebsitePopupAdmin />
              </RoleBasedRoute>
            }
          />
          <Route
            path="enquiries"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin"]}>
                <Enquirys />
              </RoleBasedRoute>
            }
          />
          <Route
            path="payments"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin"]}>
                <Payments />
              </RoleBasedRoute>
            }
          />
          <Route
            path="manage-memberships"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin"]}>
                <ManageMemberships />
              </RoleBasedRoute>
            }
          />
          <Route
            path="manage-programs"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin", "coach_admin", "coach_employee", "coach"]}>
                <ManagePrograms />
              </RoleBasedRoute>
            }
          />
          <Route
            path="manage-program-sessions"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin", "coach_admin", "coach_employee", "coach"]}>
                <ManageProgramSessions />
              </RoleBasedRoute>
            }
          />
          <Route
            path="manage-program-enrollments"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin", "coach_admin", "coach_employee", "coach"]}>
                <ManageProgramEnrollments />
              </RoleBasedRoute>
            }
          />

          {/* Routes accessible by both admin and employee */}
          <Route
            path="manage-bookings"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin"]}>
                <ManageBookings />
              </RoleBasedRoute>
            }
          />
          <Route
            path="manage-users"
            element={
              <RoleBasedRoute allowedRoles={["admin", "employee", "employee_admin"]}>
                <ManageUsers />
              </RoleBasedRoute>
            }
          />
        </Route>
      </Routes>
    </AdminLayout>
  )
}

export default AdminRoutes
